import { Form, Alert } from 'antd';
import { Text } from '@quinyx/ui';
import { useForm } from 'react-hook-form';

import {
  useGetWebpunchLink,
  useUpdateWebpunch,
} from '../../../hooks/support/webpunch';
import UpdatedWebpunch from './UpdatedWebpunch';
import StepInput from '../../../components/StepsComponent/StepInput';
import { withSupportLayout } from '../../../layouts/support';
import StepsComponent, {
  NextCallback,
} from '../../../components/StepsComponent';
import { useTranslate } from '../../../hooks/translate';

const NGLink = () => {
  const { t } = useTranslate();
  const foreignIdForm = useForm<{ foreignId: string }>();
  const updateWebpunchForm = useForm<{
    unitId: string;
    integrationKeyId: string;
    foreignId: string;
  }>({
    defaultValues: {
      foreignId: undefined,
      unitId: undefined,
      integrationKeyId: undefined,
    },
  });

  const { getWebPunch } = useGetWebpunchLink();
  const { updateWebpunch, updatedWebpunch } = useUpdateWebpunch();

  const steps = [
    {
      title: t('support.nglink.getByVirksId'),
      content: (
        <Form layout="vertical">
          <Form.Item
            label={t('support.nglink.virksId')}
            extra={t('support.nglink.virksIdExtra')}>
            <StepInput
              error={!!foreignIdForm.formState.errors.foreignId}
              required
              key="foreignId"
              name="foreignId"
              control={foreignIdForm.control}
            />
          </Form.Item>
        </Form>
      ),
    },
    {
      title: t('support.nglink.updateWebpunchLink'),
      content: (
        <Form layout="vertical">
          <Form.Item label={t('support.nglink.virksId')}>
            <StepInput
              key="foreignId"
              name="foreignId"
              control={updateWebpunchForm.control}
              disabled
            />
          </Form.Item>
          <Form.Item label={t('support.nglink.integrationKeyId')}>
            <StepInput
              key="integrationKeyId"
              name="integrationKeyId"
              control={updateWebpunchForm.control}
              disabled
            />
          </Form.Item>
          <Form.Item label={t('support.nglink.restId')}>
            <StepInput
              error={!!updateWebpunchForm.formState.errors.unitId}
              required
              key="unitId"
              name="unitId"
              control={updateWebpunchForm.control}
            />
          </Form.Item>
          <Alert
            style={{ maxWidth: '500px', margin: '40px auto 0 auto' }}
            message={t('common.pleaseNote')}
            description={t('support.nglink.updateWarning')}
            type="info"
            showIcon
          />
        </Form>
      ),
    },
    {
      title: t('support.nglink.updatedWebpunchLink'),
      content: <UpdatedWebpunch webpunch={updatedWebpunch} />,
    },
  ];

  const nextCallback: NextCallback = async (
    currentStep,
    setStepStatusError,
  ) => {
    switch (currentStep) {
      case 0:
        {
          const isForeignIdFormValid = await foreignIdForm.trigger();
          if (!isForeignIdFormValid) {
            return false;
          }

          const { foreignId } = foreignIdForm.getValues();
          if (foreignId) {
            try {
              const { data } = await getWebPunch(foreignId);
              updateWebpunchForm.reset({
                unitId: data.localId,
                integrationKeyId: data.id,
                foreignId: data.foreignId,
              });
            } catch (error) {
              setStepStatusError(t('support.nglink.fetchFailed'));
            }
          }
        }
        break;

      case 1:
        {
          const isUpdateFormValid = await updateWebpunchForm.trigger();
          if (!isUpdateFormValid) {
            return false;
          }

          const { unitId, integrationKeyId } = updateWebpunchForm.getValues();
          if (unitId && integrationKeyId) {
            try {
              await updateWebpunch({
                unitId,
                integrationKeyId,
              });
            } catch (error) {
              setStepStatusError(t('support.nglink.fetchFailed'));
            }
          }
        }
        break;

      case 2: {
        foreignIdForm.reset();
        updateWebpunchForm.reset();
        break;
      }
      default:
        break;
    }
    return true;
  };

  return (
    <>
      <Text color="SurfaceOnSurfaceAlt">
        {t('support.nglink.pageDescription')}
      </Text>
      <StepsComponent steps={steps} nextCallback={nextCallback} />
    </>
  );
};
export default withSupportLayout(NGLink);
